import { createRouter, createWebHistory } from 'vue-router'
import isLogged from '../helpers/sessionHandlers/isLogged'
import About from '../views/About.vue'
import Home from '../views/Home.vue'
import ProductData from '../views/ProductData.vue'
import StepperComponents from '../views/StepperComponents.vue'
import Login from '../views/Login.vue'
import Logout from '../views/Logout.vue'
import Protocols from '../views/Protocols.vue'
import ProtocolDetailHistory from '../views/ProtocolDetailHistory.vue'
import Wallet from '../views/Wallet.vue'
import TrackingOrder from '../views/TrackingOrder.vue'
import PublicTracking from '../views/PublicTracking.vue'

const sub_routes_create_protocol = [
  {
    path: 'produto',
    component: ProductData,
  },
  {
    path: 'confirmacao',
    component: StepperComponents,
  },  
]

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      freeAccess: true,
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: {
      freeAccess: true,
    },
  },    
  {
    path: '/tracking/:ped_codigo',
    name: 'PublicTrackingOrder',
    component: PublicTracking,
    meta: {
      freeAccess: true,
    },
  },  
  {
    path: '/about',
    name: 'About',
    component: About,
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    alias: '/home',
  },
  {
    path: '/protocolos',
    name: 'Protocols',
    component: Protocols,
  },
  {
    path: '/carteira',
    name: 'Wallet',
    component: Wallet,
  },
  {
    path: '/detalhes-pedido/:ped_codigo',
    name: 'TrackingOrder',
    component: TrackingOrder,
  },
  {
    path: '/protocol/:prt_id',
    name: 'ProtocolDetailHistory',
    component: ProtocolDetailHistory,
  },
  {
    path: '/produtos-adquiridos-online',
    name: 'ProductDataEcommerce',
    children: [
      ...sub_routes_create_protocol.map((route) => {
        route.props = { ecommerce: true }
        return route
      }),
    ],
  },
  {
    path: '/produtos-adquiridos-fora-da-loja-online',
    name: 'ProductDataReclamacao',
    children: [...sub_routes_create_protocol],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})
router.beforeEach(isLogged)

export default router